import { MediaLibraryState } from './types'

const state = (): MediaLibraryState => ({
  value: new Map(),
})

export default state
